import { render, staticRenderFns } from "./FGDataSelectForRegister.vue?vue&type=template&id=cdb8d2d0&scoped=true"
import script from "./FGDataSelectForRegister.vue?vue&type=script&lang=js"
export * from "./FGDataSelectForRegister.vue?vue&type=script&lang=js"
import style0 from "./FGDataSelectForRegister.vue?vue&type=style&index=0&id=cdb8d2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb8d2d0",
  null
  
)

export default component.exports